<template>
  <div class="template_pop" v-if="ruleViewShow">
    <div>
      <div class="el-icon-close" @click="close" />
      <div class="template_pop_title">积分规则</div>
      <div class="rule_ItemTitle">【充值新规则，轻松享优惠】</div>
      <ul class="rule_ul" v-loading="loading">
        <li v-for="(item, i) in listData" :key="item.id">
          充值
          <span v-if="i != listData.length - 1"
            >{{ item.minValue }}-{{ item.maxValue }}</span
          >
          <span v-else>大于 {{ item.minValue }}</span>
          元, 获得充值金额<span>{{ item.pointPercentage }}%</span>的积分奖励。
          <div>{{ item.remark }}</div>
        </li>
      </ul>
      <div class="rule_ItemTitle">【积分抵余额，消费更轻松】</div>
      <ul class="rule_ul">
        <li>每次消费攒积分，<span>积分直接抵现金</span>。</li>
        <li>
          下次购物时，轻松一选，<span>1 积分抵 1 元</span
          >，积分秒变余额，让您的消费更加划算！简单又实用，快来享受积分带来的实惠吧！
        </li>
      </ul>
      <el-button type="primary" size="small" @click="close">我知道了</el-button>
    </div>
  </div>
</template>
<script>
import { baseApi } from '@/api/baseApi.js'
export default {
  props: {
    ruleViewShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      listData: [],
    }
  },
  mounted() {
    this.pointRemark()
  },
  methods: {
    pointRemark() {
      this.loading = true
      baseApi
        .pointRemark()
        .then((res) => {
          this.loading = false
          this.listData = res.data
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err.error)
        })
    },
    close() {
      this.$parent.ruleViewShow = false
    },
  },
}
</script>
<style lang="scss" scoped>
.template_pop {
  >div{
    overflow: auto;
  }
  .rule_ItemTitle {
    font-size: 14px;
    color: var(--color_mainText);
    font-weight: 600;
    margin: 20px 0 10px;
  }
  .rule_ul {
    li {
      margin: 5px 0 5px 20px;
      font-size: 10px;
      font-weight: 600;
      color: #000;
      span {
        color: var(--color_basic);
        margin: 5px;
        font-size: 12px;
      }
      div {
        color: var(--color_mainText);
      }
    }
  }
}
</style>
